"use client";

import React from "react";
import { Youtube, Users, Video } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YoutubeIntelligence() {
  const channels = [{
    name: "Cloud Computing Insider",
    description: "Deep dives into enterprise cloud architecture, multi-cloud strategies, and the future of scalable infrastructure.",
    subscribers: "500K+",
    videos: "320+",
    url: "https://www.youtube.com/@CloudComputingInsider"
  }, {
    name: "Dave Linthicum is Not AI",
    description: "Exploring the intersection of human intelligence and generative AI. Cutting through the hype with real-world analysis.",
    subscribers: "500K+",
    videos: "150+",
    url: "https://www.youtube.com/@DavidIsNotAI"
  }];
  return <section data-section-id="241542" id="youtube-intelligence" className="relative w-full py-24 md:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-card/40 to-background pointer-events-none" />
      
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at center, var(--primary) 1px, transparent 1px)',
      backgroundSize: '48px 48px'
    }} />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-primary mb-4 tracking-tighter uppercase">
            YouTube Intelligence
          </h2>
          <p className="text-lg md:text-xl font-mono text-muted-foreground max-w-2xl mx-auto uppercase tracking-wider">
            Latest Insights from the Cloud & AI Frontier
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {channels.map((channel, i) => <div key={i} data-index={i} className="group relative p-8 bg-card/30 backdrop-blur-xl border border-border rounded-lg shadow-xl transition-all duration-300 hover:border-primary/50 hover:shadow-2xl hover:-translate-y-1 flex flex-col h-full">
              <div className="flex items-start justify-between mb-6">
                <div className="p-3 rounded-md bg-primary/10 text-primary">
                  <Youtube className="size-8" />
                </div>
                <div className="flex gap-4 text-[10px] font-mono text-muted-foreground uppercase tracking-widest">
                  <div className="flex items-center gap-1">
                    <Users className="size-3 text-primary" />
                    <span>{channel.subscribers} SUBS</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Video className="size-3 text-primary" />
                    <span>{channel.videos} VIDEOS</span>
                  </div>
                </div>
              </div>

              <h3 className="text-2xl font-default font-bold text-foreground mb-3 group-hover:text-primary transition-colors">
                {channel.name}
              </h3>
              
              {i === 0 ? <div className="mb-8 flex-grow overflow-hidden rounded-md border border-border/50">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/Screenshot 2026-05-22 at 2.19.24 PM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/Screenshot 2026-05-22 at 2.19.24 PM.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/Screenshot 2026-05-22 at 2.19.24 PM.png-wvc-sizes" alt={channel.name} className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" decoding="async" />
                </div> : <div className="mb-8 flex-grow overflow-hidden rounded-md border border-border/50">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/Screenshot 2026-05-22 at 2.16.11 PM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/Screenshot 2026-05-22 at 2.16.11 PM.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/Screenshot 2026-05-22 at 2.16.11 PM.png-wvc-sizes" alt={channel.name} className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" decoding="async" />
                </div>}

              <div className="mt-auto">
                <Button asChild className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-mono uppercase tracking-wider py-6">
                  <Link to={channel.url} newTab>
                    Subscribe to Channel
                  </Link>
                </Button>
              </div>

              {}
              <div className="absolute top-0 right-0 w-12 h-12 border-t border-r border-primary/20 rounded-tr-lg pointer-events-none group-hover:border-primary/40 transition-colors" />
            </div>)}
        </div>
      </div>
    </section>;
}